export default "__VITE_ASSET__B0Oz238H__"